import AxiosService from '../AxiosService';
import { queryString, apiUrl } from '../config/globals';

export const notificationList = (data, params) => AxiosService.post(`${apiUrl('notification', 'private')}/search?${queryString(params)}`, data);

export const emailAccountList = (data, params) => AxiosService.post(`${apiUrl('email-account', 'private')}/search?${queryString(params)}`, data);

export const emailContentSearch = (data, params) => AxiosService.post(`${apiUrl('email-content', 'private')}/search?${queryString(params)}`, data);

export const viewEmailContent = (data) => AxiosService.get(`${apiUrl('email-content', 'private')}/view-by-notification?${queryString(data)}`);

export const updateEmailContent = (data) => AxiosService.put(`${apiUrl('email-content', 'private')}/update`, data);

export const notificationUpdate = (data) => AxiosService.put(`${apiUrl('notification', 'private')}/update`, data);

export const addEmailContent = (data) => AxiosService.post(`${apiUrl('email-content', 'private')}/save`, data);
